import { render, staticRenderFns } from "./QConfigureAffiliateWidget.vue?vue&type=template&id=a1ea1f40&scoped=true&"
import script from "./QConfigureAffiliateWidget.vue?vue&type=script&lang=js&"
export * from "./QConfigureAffiliateWidget.vue?vue&type=script&lang=js&"
import style0 from "./QConfigureAffiliateWidget.vue?vue&type=style&index=0&id=a1ea1f40&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1ea1f40",
  null
  
)

export default component.exports